
import { UFDisciplineRaw, UFliterals } from "@/utils/literals";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ActivityForm from "@/components/admin/entityForm/ActivityForm.vue";
import TipGroupForm from "@/components/admin/entityForm/TipGroupForm.vue";
import SequenceForm from "@/components/admin/entityForm/SequenceForm.vue";
import { IUser } from "@/schemas/IUser";
import { mapGetters, mapState } from "vuex";
import { duplicateSlideImages } from "@/utils";
import { ISetting } from "@/schemas/ISetting";
import { IItem } from "@/schemas/IItem";
import { ISequence } from "@/schemas/ISequence";
import { IActivity } from "@/schemas/IActivity";
import VideoPlayer from "@/components/VideoPlayer.vue";
import { apiUrl } from "@/env";

@Component({
  components: { VideoPlayer, SequenceForm, TipGroupForm, ActivityForm },
  computed: {
    ...mapState("user", ["users"]),
    ...mapGetters("user", [
      "canDuplicate",
      "getUserId",
      "canCreate",
      "isAdministrator",
    ]),
  },
})
export default class CrudTable extends Vue {
  @Prop({ required: true, type: Array })
  readonly headers!: Array<string>;
  @Prop({ type: Array, required: true })
  readonly data!: Array<Record<string, any>>;
  @Prop({ type: String, required: true })
  readonly tableTitle!: string;
  @Prop({ type: String, required: true })
  readonly storeModuleName!: string;
  @Prop({ type: Function, required: true })
  readonly updateHandler!: CallableFunction;
  @Prop({ type: Function, required: true })
  readonly createHandler!: CallableFunction;
  @Prop({ type: Function, required: true })
  readonly deleteHandler!: CallableFunction;

  private search = "";
  private expanded = [];
  private dialog = false;
  private dialog2 = false;
  private dialogDelete = false;
  private dialogDisplayVideo = false;
  private dialogCancel = false;
  private editedIndex = -1;
  private editedItem: Record<string, any> = {};
  private dialogConsult = false;
  private dialogDuplicate = false;
  private canDuplicate: boolean | undefined;
  private canCreate: boolean | undefined;
  private users: IUser[] | undefined;
  private getUserId: string | undefined;
  private tab = null;
  private tabs = ["mine", "other"];

  activity_id = "";
  apiUrl = "";
  video_name = "";
  title = "";

  data(): any {
    return {
      firstIteration: false,
      firstIterationM: false,
      expandedContent: "",
    };
  }

  getValidationColor(itemValidation) {
    switch (itemValidation) {
      case true:
        return "green darken-1";
      case false:
        return "grey darken-1";
      case null:
        return "grey darken-1";
    }
  }

  getValidationColor2(itemValidation) {
    switch (itemValidation) {
      case true:
        return "green";
      case false:
        return "grey";
      case null:
        return "grey";
    }
  }

  getValidationSymbol(itemValidation) {
    switch (itemValidation) {
      case true:
        return "mdi-check";
      case false:
        return "mdi-close";
      case null:
        return "mdi-close";
    }
  }

  getValidationText(itemValidation) {
    switch (itemValidation) {
      case true:
        return "Validée";
      case false:
        return "Non validée";
      case null:
        return "Non validée";
    }
  }

  get columns(): Array<Record<string, any>> {
    let columns: Record<string, any>[] = [];
    // delete this.headers[2] // TO DO => supprimer plutôt dans les headers
    if (this.storeModuleName == "tipGroup") {
      delete this.headers[2];
    }
    if (this.storeModuleName == "activity") {
      this.headers[1] = "isValidated";
      delete this.headers[10];
      delete this.headers[2];
      delete this.headers[3];
      delete this.headers[4];
    }
    this.headers.map((header) => {
      if (
        header == "guideline" ||
        header == "id" ||
        header == "background_img" ||
        header == "authorized_instructors" ||
        header == "description"
      ) {
        return;
      }
      if (header == "single_session_time" || header == "group_session_time") {
        columns.push({
          text: this.getUFHeader(header),
          align: "center",
          value: header,
          width: "100px",
          sortable: true,
        });
        return;
      }
      if (header == "isValidated") {
        columns.push({
          text: this.getUFHeader(header),
          align: "center",
          value: "is_validated",
          width: "200px",
          sortable: true,
        });
        return;
      }
      if (header == "author_id") {
        columns.push({
          text: this.getUFHeader(header),
          align: "center",
          value: "author_nickname",
          sortable: true,
        });
        return;
      }
      if (header == "title") {
        columns.push({
          text: this.getUFHeader(header),
          align: "start",
          value: header,
          sortable: true,
        });
        return;
      }
      columns.push({
        text: this.getUFHeader(header),
        align: "center",
        value: header,
        sortable: true,
      });
    });
    if (this.data.length) {
      columns.push({
        text: "Actions",
        value: "actions",
        sortable: false,
        width: "170px",
      });
    }
    if (
      this.firstIteration == true &&
      this.firstIterationM == true &&
      columns.length == 12
    ) {
      // Bon c'est un peu bourrin mais ça marche ?? A update si nb colonne change ?? A corriger si sequence/guidage atteignent 12 colonnes (unlikely)
      if (columns[9].value == "author_nickname") {
        delete columns[9];
      }
      if (columns[10].value == "disciplineRaw") {
        delete columns[10];
      }
    }
    return columns;
  }

  created(): void {
    this.firstIteration = false;
    this.firstIterationM = false;

    this.tab = 1;
    console.log(this.storeModuleName);
    if (this.storeModuleName == "tipGroup" && !this.isAdministrator) {
      this.tabs = ["other"];
    } else {
      this.tabs = ["mine", "other"];
    }
    console.log(this.tab);
  }

  get formTitle(): string {
    return this.editedIndex === -1
      ? `${this.getUFHeader("creation")} : ${this.tableTitle}`
      : `${this.getUFHeader("edition")} : ${this.tableTitle}`;
  }

  @Watch("dialog")
  dialogChanged(val: boolean): void {
    val || this.close();
  }

  @Watch("dialogDelete")
  dialogDeleteChanged(val: boolean): void {
    val || this.closeDelete();
  }

  @Watch("dialog2")
  dialog2Changed(val: boolean): void {
    val || this.close2();
  }

  @Watch("dialogDisplayVideo")
  dialogDisplayVideoChanged(val: boolean): void {
    val || this.closeVideo();
  }

  redirectToSequence(sequenceId: string): void {
    this.$router.push({
      name: "sequence",
      params: {
        id: sequenceId,
      },
    });
  }

  /**
   * Retrieve user friendly header name
   * @param header
   */
  getUFHeader(header: string): string {
    return UFliterals[header];
  }

  editItem(item: Record<string, any>): void {
    this.editedIndex = this.data.indexOf(item);
    this.editedItem = Object.assign({}, item);
    let type = item.type ? item.type : "";
    this.$store.dispatch(`${this.storeModuleName}/fetchFullById`, {
      id: item.id,
      type,
      next: (item: Record<string, any>) => {
        if (this.storeModuleName == "activity") {
          item.items.sort((a, b) => a.list_position - b.list_position);
        }

        this.editedItem = Object.assign({}, this.editedItem, item);
        this.$nextTick(function () {
          this.dialog = true;
        });
      },
    });
  }

  validateItem(item: Record<string, any>): void {
    this.editedIndex = this.data.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog2 = true;
  }

  consultItem(item: Record<string, any>): void {
    this.editedIndex = this.data.indexOf(item);
    let type = item.type ? item.type : "";
    this.$store.dispatch(`${this.storeModuleName}/fetchFullById`, {
      id: item.id,
      type,
      next: (item: Record<string, any>) => {
        this.editedItem = Object.assign({}, item);
        this.dialogConsult = true;
      },
    });
  }

  deleteItem(item: Record<string, any>): void {
    this.editedIndex = this.data.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialogDelete = true;
  }

  duplicateItem(item: Record<string, any>): void {
    this.editedIndex = this.data.indexOf(item);
    let type = item.type ? item.type : "";
    this.$store.dispatch(`${this.storeModuleName}/fetchFullById`, {
      id: item.id,
      type,
      next: (fullItem: Record<string, any>) => {
        // When duplicate we don't want to keep the same id
        if (fullItem.id) delete fullItem.id;
        // If item is a sequence, we do not want to duplicate
        // code, is open, authorized instructors
        if (fullItem.code) delete fullItem.code;
        if (fullItem.is_open) fullItem.is_open = false;
        if (fullItem.is_validated) delete fullItem.is_validated;
        if (fullItem.authorized_instructors)
          delete fullItem.authorized_instructors;
        // Case if it's a sequence
        if (fullItem.settings) {
          fullItem.settings.map((setting: ISetting) => {
            delete setting.id;
            delete setting.sequence_id;
            delete setting.opened_at;
          });
        }
        // Case if it's an activity
        if (fullItem.items) {
          fullItem.items.map((item: IItem) => {
            delete item.id;
            delete item.activity_id;
          });
        }

        // Update the created at and author_id to the current author
        if (fullItem.created_at) delete fullItem.created_at;
        if (fullItem.author_id) delete fullItem.author_id;

        if (fullItem.slides) duplicateSlideImages(fullItem.slides);
        this.editedItem = Object.assign({}, fullItem);
        this.dialogDuplicate = true;
      },
    });
  }

  deleteItemConfirm(): void {
    this.deleteHandler(this.editedItem.id);
    this.closeDelete();
  }

  get videoUrl(): string {
    return apiUrl && this.activity_id && this.video_name
      ? `${apiUrl}/video/${this.activity_id}/${this.video_name}`
      : "";
  }

  displayVideo(item: Record<string, any>): void {
    this.editedIndex = this.data.indexOf(item);
    this.editedItem = Object.assign({}, item);

    this.activity_id = this.editedItem.id;
    this.apiUrl = apiUrl;
    this.video_name = item.video;
    this.title = this.editedItem.title;

    this.dialogDisplayVideo = true;
  }

  close(): void {
    this.dialog = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, {});
      this.editedIndex = -1;
    });
  }

  closeDelete(): void {
    this.dialogDelete = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, {});
      this.editedIndex = -1;
    });
  }

  closeVideo(): void {
    this.dialogDisplayVideo = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, {});
      this.editedIndex = -1;
    });
  }

  close2(): void {
    this.dialog2 = false;
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, {});
      this.editedIndex = -1;
    });
  }

  editValidation(state): void {
    this.editedItem.is_validated = state;
    let activityToValidate = this.editedItem;
    activityToValidate.discipline = activityToValidate.disciplineRaw;
    if (this.getUFDisci(activityToValidate.discipline)) {
      activityToValidate.discipline = this.getUFDisci(
        activityToValidate.discipline
      );
    }
    this.$store.dispatch("activity/updateActivity", {
      id: this.editedItem.id,
      activity: activityToValidate,
    });
    this.close2();
  }

  cancelItem(): void {
    this.dialogCancel = true;
  }

  closeCancel(): void {
    this.dialogCancel = false;
    this.dialogDuplicate &&= false;
  }

  leaveConsult(): void {
    this.dialogConsult = false;
    this.close();
  }

  saveDuplicate(objectToSubmit: Record<string, any>): void {
    // TODO: if it is a sequence check that settings are duplicated but not sessions
    this.createHandler(objectToSubmit);
    this.dialogDuplicate = false;
    this.close();
  }

  cancelItemConfirm(): void {
    this.close();
    this.closeCancel();
  }

  save(objectToSubmit: Record<string, any>): void {
    if (this.editedIndex > -1) {
      this.updateHandler(objectToSubmit, this.editedItem.id);
    } else {
      this.createHandler(objectToSubmit);
    }
    this.close();
  }

  getExpanded(): string | null {
    return this.storeModuleName === "activity" ? "guideline" : "description";
  }

  getItemContent(item): any {
    return item[this.getExpanded()];
  }

  getActivityContent(): any {
    if (this.storeModuleName == "activity") {
      this.expandedContent = "Chargement";
      setTimeout(() => {
        this.expandedContentChange();
      }, "1000");
    } else if (this.storeModuleName == "sequence") {
      this.expandedContent = "Chargement";
      setTimeout(() => {
        this.expandedSequenceContent();
      }, "1000");
    }
  }

  async expandedSequenceContent(): Promise<void> {
    if (this.expanded[0] !== undefined) {
      const sequenceId = this.expanded[0].id;
      const sequence = (await this.$store.dispatch(
        `${this.storeModuleName}/fetchFullById`,
        {
          id: sequenceId,
        }
      )) as Record<string, any>;

      let htmlContent =
        "<br/><b>Activités de la sequence :</b><div style='margin-top:20px'><ul>";

      const settingDetailsList: Record<string, any>[] = [];
      for (const setting of sequence.settings || []) {
        await new Promise<void>((resolve) => {
          this.$store.dispatch(`setting/fetchSettingSessions`, {
            settingId: setting.id,
            next: (details: Record<string, any>) => {
              console.log("details received:", details);
              settingDetailsList.push({ ...setting, details });
              resolve();
            },
          });
        });
      }

      for (const item of settingDetailsList) {
        const statusLabel = !item.details?.length
          ? "Créée"
          : item.details[0].status === "finished"
          ? "Terminée"
          : item.details[0].status === "created"
          ? "Créée"
          : "En cours";
        htmlContent += `<li>${item.activity?.title || "N/A"} - ${
          item.activity?.discipline || "N/A"
        } - ${statusLabel}</li>`;
      }
      htmlContent += "</ul>";
      this.expandedContent = htmlContent;
    }
  }

  async expandedContentChange(): any {
    let type = "ranking";
    if (this.expanded[0] !== undefined) {
      let id = this.expanded[0].id;
      await this.$store.dispatch(`${this.storeModuleName}/fetchFullById`, {
        id,
        type,
        next: (item: Record<string, any>) => {
          //mettre la consigne tronquée a 250 characters max

          let sortedItem = item.items.sort(
            (a, b) => a.expected_rank - b.expected_rank
          );
          //item.guideline+ pour ravoir la consigne dans l'expanded content
          let htmlContent =
            "<br/><b>Classement correct et justifications</b><div style='margin-top:20px'><table style='border-collapse: collapse;'>";
          for (let i = 0; i < sortedItem.length; i++) {
            let label = "";
            let justification = "";
            if (sortedItem[i].label.length > 100) {
              label = sortedItem[i].label.substring(0, 50);
              label = label + "...";
            } else {
              label = sortedItem[i].label;
            }
            if (sortedItem[i].justification != null) {
              justification = sortedItem[i].justification;
            }

            htmlContent =
              htmlContent +
              "<tr style='width:40px;border-bottom:1px solid #e0e0e0;'><td style='width:40px;border-bottom:1px solid #e0e0e0;padding: 15px'>" +
              sortedItem[i].expected_rank +
              "</td><td style='width:550px;padding: 15px'>" +
              label +
              "</td><td style='padding: 15px'>" +
              justification +
              "</td></tr>";
          }
          htmlContent = htmlContent + "</table></div>";
          this.expandedContent = htmlContent;
          console.log(this.expandedContent);
        },
      });
    }
  }

  getAuthor(id: string): string {
    let user = this.users?.find((user: IUser) => user.id === id);
    return user ? user.username : this.getUFHeader("undetermined");
  }

  isEnableToWrite(author_id: string): boolean {
    return this.getUserId == author_id || this.isAdministrator;
  }

  getUFLabel(key: string): string {
    return UFliterals[key];
  }

  getUFDisci(key: string): string {
    return UFDisciplineRaw[key];
  }

  get filteredData(): Array<Record<string, any>> {
    let userId = this.getUserId;
    let data = [];
    if (this.tab === "tab-mine") {
      this.data.map((row) => {
        if (
          row.author_id === userId ||
          row.authorized_instructors?.find((auth) => auth === userId)
        ) {
          if (this.getAuthor(row.author_id) != "Non determiné") {
            row.author_nickname = this.getAuthor(row.author_id);
          }
          if (this.storeModuleName == "activity") {
            row.disciplineRaw = row.discipline;
            row.discipline = this.getUFLabel(row.discipline);
            if (row.discipline == undefined) {
              row.discipline = row.disciplineRaw;
            }
          }
          data.push(row);
        }
      });
      this.firstIterationM = true;
      return data;
    }
    this.data.map((row) => {
      if (row.author_id != userId) {
        if (this.getAuthor(row.author_id) != "Non determiné") {
          row.author_nickname = this.getAuthor(row.author_id);
        }
        if (this.storeModuleName == "activity") {
          row.disciplineRaw = row.discipline;
          row.discipline = this.getUFLabel(row.discipline);
          if (row.discipline == undefined) {
            row.discipline = row.disciplineRaw;
          }
        }
        data.push(row);
      }
    });
    this.firstIteration = true;
    return data;
  }
}
